import type { ComponentType } from 'react';
import { lazyComponent, registerPreload } from '../lib/lazy';
import { toolPath } from './registry';

/**
 * The widget each tool page renders, keyed by the slug in ./registry.ts. Kept
 * apart from the registry so the node-side route list never imports React.
 * Widget components live in src/components/tools/, and each one is its own
 * chunk, loaded by its tool page (see src/lib/lazy.ts).
 */
const LOADERS: Record<string, () => Promise<ComponentType>> = {
  'mcp-security-checklist': () => import('../components/tools/McpSecurityChecklist').then((m) => m.default),
  'mcp-tool-permission-planner': () => import('../components/tools/McpToolPermissionPlanner').then((m) => m.default),
};

export const WIDGETS: Record<string, ComponentType> = Object.fromEntries(
  Object.entries(LOADERS).map(([slug, load]) => {
    const { Component, preload } = lazyComponent(load);
    registerPreload(toolPath(slug), preload);
    return [slug, Component];
  }),
);
